import { useQuery } from "@tanstack/react-query";
import { catResults } from "../../../api/routes";

export const useCatResults = (reportId: string) => {
  const query = useQuery({
    queryKey: ["cat-results", reportId],
    queryFn: () => catResults(reportId),
  });
  return { data: query.data ?? null, isLoading: query.isLoading };
};
